import { useEffect, useState } from "react";

const DURATION_SECONDS = 17 * 60 + 34;
const START = Date.now();

type CountdownParts = { hours: number; minutes: number; seconds: number };

function compute(): CountdownParts {
  const elapsed = Math.floor((Date.now() - START) / 1000);
  const remaining = DURATION_SECONDS - (elapsed % (DURATION_SECONDS + 1));
  return {
    hours: Math.floor(remaining / 3600),
    minutes: Math.floor((remaining % 3600) / 60),
    seconds: remaining % 60,
  };
}

/** Counts down from 00:17:34 to 00:00:00, then restarts automatically. All instances stay in sync. */
export function useLoopingCountdown(): CountdownParts {
  const [parts, setParts] = useState<CountdownParts>(compute);

  useEffect(() => {
    const id = window.setInterval(() => setParts(compute()), 1000);
    return () => window.clearInterval(id);
  }, []);

  return parts;
}
